<mat-card [ngClass]="{'disabled': isDisabled}">
  <ds-lib-hover color="primary" gap="medium"></ds-lib-hover>
  <div class="icon-container">
    <mat-icon *ngIf="!svgIcon">
      <ng-content></ng-content>
    </mat-icon>
    <mat-icon *ngIf="svgIcon" [svgIcon]="svgIcon" #custom>
    </mat-icon>
  </div>
  <div class="text">{{text}}</div>
</mat-card>